import script from "./ServicesList.vue?vue&type=script&setup=true&lang=js"
export * from "./ServicesList.vue?vue&type=script&setup=true&lang=js"

import "./ServicesList.vue?vue&type=style&index=0&id=45d69775&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45d69775"]])

export default __exports__